import { Berth } from 'data/models/Berth';
import { TopicCardOptions } from 'data/models/TopicCard';
import { TopicCardTemplate as ServerTopicCardTemplate } from 'server/models/TopicCardTemplate';

export { TopicCardTemplateData, TopicCardTemplateOptions } from 'server/models/TopicCardTemplate';

export class TopicCardTemplate extends ServerTopicCardTemplate {
    EffectiveTitle() {
        return this.AmenityTypeId() === null ? this.Title()
            : `Amenity | ${this.AmenityType() ? this.AmenityType()!.Name() : ''}`;
    }

    EffectiveRemarks() {
        return this.AmenityTypeId() === null ? this.Remarks()
            : this.AmenityType() && this.AmenityType()!.Description();
    }

    TitleForAnswer(berth : () => Berth | null) {
        return this.AmenityTypeId() === null ?
            this.Title() :
            berth() ?
                `${berth()!.Location() ? berth()!.Location()!.Name() : ''} | ${this.AmenityType() ? this.AmenityType()!.Name() : ''}`
                : '';
    }

    ToAnswerData(berth : () => Berth | null) : TopicCardOptions {
        return {
            Id: 0,
            TemplateId: this.Id(),
            AmenityTypeId: this.AmenityTypeId(),
            BerthId: berth() ? berth()!.Id() : null,
            Title: this.TitleForAnswer(berth),
            Question: this.Question(),
            QuestionType: this.QuestionType(),
            TimeEntry: {
                HasTimeEntry: this.TimeEntry.HasTimeEntry(),
                Label: this.TimeEntry.Label()
            },
            Remarks: this.Remarks()
        };
    }
}


// WEBPACK FOOTER //
// ./data/models/TopicCardTemplate.ts